/**
 * SectionCard — a titled card used for settings/dashboard sections.
 * `tone="danger"` renders the destructive variant (danger-zone panels).
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface SectionCardProps {
  title: ReactNode;
  description?: ReactNode;
  tone?: 'default' | 'danger';
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function SectionCard({
  title,
  description,
  tone = 'default',
  children,
  footer,
  className,
}: SectionCardProps) {
  const danger = tone === 'danger';
  return (
    <section
      className={cn(
        'rounded-xl border bg-card p-7',
        danger ? 'border-destructive-border bg-[#fdfafa]' : 'border-border',
        className,
      )}
    >
      <h2 className={cn('text-base font-semibold', danger && 'text-destructive')}>{title}</h2>
      {description && <p className="mt-0.5 text-[13.5px] text-muted-foreground">{description}</p>}
      <div className="mt-5">{children}</div>
      {footer && <div className="mt-5">{footer}</div>}
    </section>
  );
}
